module.exports = new __parcel__URL__("uber-grocery.8d114004.png").toString();